export const openModal =
  (modalProps = {}) =>
  (dispatch) => {
    dispatch({
      type: 'SHOW_MODAL',
      modalProps: { ...modalProps, open: true },
      value: undefined,
    });
  };

export const closeModal = () => (dispatch) => {
  dispatch({
    type: 'HIDE_MODAL',
    value: undefined,
  });
};

export const updateValueModal = (value) => (dispatch) => {
  dispatch({
    type: 'UPDATE_VALUE_MODAL',
    value,
  });
};
